import { useMutation } from "@tanstack/react-query";
import { createPortal } from "../api/createPortal";

/**
 * Open the Polar customer portal. The caller redirects the browser to the
 * returned URL on success.
 */
export function usePortal() {
  return useMutation({ mutationFn: createPortal });
}
